module.exports = __webpack_public_path__ + "static/media/logo.bb63e3d7.svg";